// EXTERNAL IMPORTS
import { all, spawn, put, take } from "redux-saga/effects";

// ABSOLUTE PATH IMPORTS
import {
  SSO_GET_TOKEN_URL,
  SSO_RENEW_TOKEN_URL,
  OKTELL_WS_URL,
  USE_RAVEN,
} from "config";
import gqlclient from "model/client";
import { searchClients } from "model/gql/queries";
import storeShape from "./storeShape";
import {
  saga as handleError,
  CONSTANTS as HANDLE_ERROR,
} from "@lifepay/redux-subsystem-handle-error";
// RELATIVE PATH IMPORTS
// import selectors from './selectors';

// sagas:
import app from "./subsystems/app/saga";
import clients from "./subsystems/clients/saga";
import { saga as user } from "@lifepay/redux-subsystem-user";
import { saga as access } from "@lifepay/redux-subsystem-access";

export default function* rootSaga() {
  if (USE_RAVEN) {
    yield spawn(handleError);
    yield put({ type: HANDLE_ERROR.START });
    yield take(HANDLE_ERROR.STARTED);
  }
  yield all([
    spawn(clients, {
      storeShape,
      gqlclient: gqlclient,
      oktellSocketUrl: OKTELL_WS_URL,
      queries: {
        searchClients,
      },
      // init options
    }),
    spawn(user, {
      getTokenURL: SSO_GET_TOKEN_URL,
      renewTokenURL: SSO_RENEW_TOKEN_URL,
    }),
    spawn(access, {
      storePath: ["access"],
    }),
  ]);
  yield spawn(app, {
    storeShape,
    gqlclient: gqlclient,
    // init options
  });
}



// WEBPACK FOOTER //
// ./src/model/sagas.js